import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { DataTable } from '@openedx/paragon';

// Format mark display for CS251
const formatCS251Mark = (marks) => {
  const num = parseFloat(marks);
  if (Number.isInteger(num)) {
    return num;
  }
  if (!isNaN(num)) {
    return parseFloat(num.toFixed(2));
  }
  return marks;
};

// Process CS251 data
const processCS251Data = (data) => {
  let totalPercentage = '';
  const iclickerData = [];

  if (!Array.isArray(data)) {
    return { totalPercentage, iclickerData };
  }

  data.forEach((item) => {
    const name = item.assignmentName || item.assignment_name;
    const marks = item.marks;

    if (name === 'Total %') {
      totalPercentage = marks;
    } else if (!name?.startsWith('block-v1')) {
      // Skip block-v1 entries as they update existing edX problems
      iclickerData.push({
        name: name,
        marks: formatCS251Mark(marks),
      });
    }
  });

  return {
    totalPercentage,
    iclickerData,
  };
};

// Helper function to render a DataTable for a section
const renderSectionTable = (sectionData, sectionTitle, intl) => {
  if (!sectionData || sectionData.length === 0) {
    return null;
  }

  const tableData = sectionData.map((item) => ({
    name: item.name,
    score: item.marks,
  }));

  return (
    <div className="my-3" key={sectionTitle}>
      <DataTable
        data={tableData}
        itemCount={tableData.length}
        columns={[
          {
            Header: sectionTitle,
            accessor: 'name',
            headerClassName: 'h5 mb-0',
            cellClassName: 'mw-100',
          },
          {
            Header: 'Score',
            accessor: 'score',
            headerClassName: 'justify-content-end h5 mb-0',
            cellClassName: 'align-top text-right small',
          },
        ]}
      >
        <DataTable.Table />
      </DataTable>
    </div>
  );
};

const CS251Grades = ({ data, intl }) => {
  // Defensive check: ensure data is an array
  if (!Array.isArray(data)) {
    return null;
  }

  const processed = processCS251Data(data);

  return (
    <section className="text-dark-700">
      <h3 className="h4 mb-3">iClicker Participation</h3>

      {processed.totalPercentage && (
        <div className="total-percentage mb-3">
          <strong>Total: {processed.totalPercentage}%</strong>
        </div>
      )}

      {renderSectionTable(processed.iclickerData, 'iClicker Sessions', intl)}
    </section>
  );
};

CS251Grades.propTypes = {
  data: PropTypes.array,
  intl: intlShape,
};

CS251Grades.defaultProps = {
  data: [],
};

export default injectIntl(CS251Grades);
